import {actionTypes} from "../storeConstants";

export const updateComponentAction = (component) => {
    return ({
        type: actionTypes.UPDATE_COMPONENT,
        payload: component
    });
}